import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

class UnsubscribeMessageModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices',
        '$timeout'
    ];

    private close: any;
    private dismiss: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService
    ) {
        $scope.ok = () => {
            this.close();
        };
        $scope.cancel = () => {
            this.dismiss({ $value: 'cancel' });
        };
    }
}

export const UnsubscribeMessageModalComponent: ng.IComponentOptions = {
    template: require('./unsubscribe-message-modal.html'),
    controller: UnsubscribeMessageModalController,
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/unsubscribe-message-modal/unsubscribe-message-modal.ts